import React from "react";

import '../css/App.css';
import logo from '../images/logo.png';
import Socket from "../plugins/Socket";
import Alerts from "./Alerts";
import Facturacion from "./Facturacion";

var cantidad_actual= 100, taxes = 7.66;
var options="";
const socket = new Socket();

function mxnformat(data){
    return Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(data) + " MXN"
}

function usdformat(data){
    return Intl.NumberFormat('es-MX',{style:'currency',currency:'USD'}).format(data)
}

function checkValidates(reference){
    var container = reference.parentElement.parentElement;
    var flag = true;

    container.querySelectorAll("input").forEach(element=>{
        if (!element.parentElement.classList.contains("is-valid")){
            flag = false;
        }
    })

    if (!flag){
        container.querySelector(".button-container button").classList.add("disabled")
        container.querySelector(".button-container button").setAttribute("disabled","disabled")
    }else{
        container.querySelector(".button-container button").classList.remove("disabled")
        container.querySelector(".button-container button").removeAttribute("disabled")
    }
}
function handleFocus(evt){
    evt.target.classList.add("active")
    evt.target.previousElementSibling.classList.add("focus")
}

function handleBlur(evt){
    if (evt.target.type.localeCompare("number")){
        evt.target.type = "text"
    }

    if (evt.target.value.length === 0){
        evt.target.classList.remove("active")
        evt.target.previousElementSibling.classList.remove("focus")
    }
}

function isValid(element){
    element.classList.add("is-valid")
    element.classList.remove("is-invalid")
}

function isInvalid(element){
    element.classList.add("is-invalid")
    element.classList.remove("is-valid")
}

function handleAmount(evt){
    var options = JSON.parse(localStorage.getItem("options"))
    document.querySelector(".taxes input").checked = false;
    var amount_regex = new RegExp("^[0-9]{2,}$");
    if (amount_regex.test(evt.target.value)){
        var cantidad =Number(evt.target.value);

        if (socket.isEng()){
            if (cantidad >= 10){
                document.querySelector(".amount-container h2").setAttribute("amount",evt.target.value)
                if (options.currency == 1) {
                    document.querySelector(".cantidad").textContent = mxnformat(((cantidad * .036) + 3) * 1.16)
                    document.querySelector(".amount-container h2").textContent = mxnformat(evt.target.value)
                }else{
                    document.querySelector(".cantidad").textContent = usdformat(((cantidad * .036) + 3) * 1.16)
                    document.querySelector(".amount-container h2").textContent = usdformat(evt.target.value)
                }
                isValid(evt.target.parentElement)
                document.querySelector(".mensaje").textContent = ""
                cantidad_actual = cantidad;
                taxes = ((cantidad*.036)+3)*1.16;
            }else{
                isInvalid(evt.target.parentElement)
                document.querySelector(".mensaje").textContent = "Error: The amount can only have numbers and must be higher than 10"
            }
        }else{
            if (cantidad >= 100){
                document.querySelector(".amount-container h2").setAttribute("amount",evt.target.value)
                if (options.currency == 1) {
                    document.querySelector(".cantidad").textContent = mxnformat(((cantidad * .036) + 3) * 1.16)
                    document.querySelector(".amount-container h2").textContent = mxnformat(evt.target.value)
                }else{
                    document.querySelector(".cantidad").textContent = usdformat(((cantidad * .036) + 3) * 1.16)
                    document.querySelector(".amount-container h2").textContent = usdformat(evt.target.value)
                }
                isValid(evt.target.parentElement)
                document.querySelector(".mensaje").textContent = ""
                cantidad_actual = cantidad;
                taxes = ((cantidad*.036)+3)*1.16;

            }else{
                isInvalid(evt.target.parentElement)
                document.querySelector(".mensaje").textContent = "Error: El donativo debe ser mayor a 100"
            }
        }

    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()) {
            document.querySelector(".mensaje").textContent = "Error: The amount can only have numbers and must be higher than 10"
        }else{
            document.querySelector(".mensaje").textContent = "Error: La cantidad únicamnete puede llevar números y debe ser mayor a 100"
        }
    }

    checkValidates(evt.target)
}


function handleName(evt){
    var name_regex = new RegExp("^[A-ZÁÉÍÓÚÑa-záéíóúñ]{1,}( [A-ZÁÉÍÓÚÑa-záéíóúñ]{1,})*$");
    if (name_regex.test(evt.target.value)){
        isValid(evt.target.parentElement)
        evt.target.parentElement.parentElement.querySelector(".mensaje").textContent = ""
    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()){
            evt.target.parentElement.parentElement.querySelector(".mensaje").textContent = "Error: The name cannot have a space at the end and must not have numbers"
        }else{
            evt.target.parentElement.parentElement.querySelector(".mensaje").textContent = "Error: el nombre no puede tener espacio al final y no debe contener números"
        }
    }

    checkValidates(evt.target)
}

function handleEmail(evt){
    var email_regex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
    if (email_regex.test(evt.target.value)){
        isValid(evt.target.parentElement)
        document.querySelector(".mensaje").textContent = ""
    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()){
            document.querySelector(".mensaje").textContent = "Error: The email isn't a valid email"
        }else{
            document.querySelector(".mensaje").textContent = "Error: el correo no parece ser un email valido"
        }
    }

    checkValidates(evt.target)
}

function handlePhone(evt){
    var phone_regex = new RegExp("^[0-9]{10}$");
    if (phone_regex.test(evt.target.value)){
        isValid(evt.target.parentElement)
        document.querySelector(".mensaje").textContent = ""
    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()) {
            document.querySelector(".mensaje").textContent = "Error: The phone number must have only numbers and only 10 digits"
        }else{
            document.querySelector(".mensaje").textContent = "Error: el número telefónico debe contener únicamente números y debe de contener únicamente 10 dígitos"
        }
    }

    checkValidates(evt.target)
}

function handleCard(evt){
    var card_regex = new RegExp("^[0-9]{15,16}$");
    if (card_regex.test(evt.target.value)){
        isValid(evt.target.parentElement)
        document.querySelector(".bank-information .mensaje").textContent = ""
    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()){
            document.querySelector(".bank-information .mensaje").textContent = "Error: The card number must have only numbers and only 15 or 16 digits"
        }else{
            document.querySelector(".bank-information .mensaje").textContent = "Error: el número de tarjerta debe contener únicamente números y debe de contener únicamente 15 ó 16 dígitos"
        }
    }

    checkValidates(evt.target)
}
function handleClick(evt){
    document.querySelector(".information-container").classList.add("d-none")
    document.querySelector(".bank-information").classList.remove("d-none")
}

function handleMonth(evt){
    const month_exp = new RegExp("^0[1-9]|1[0-2]$")
    if (month_exp.test(evt.target.value)){
        isValid(evt.target.parentElement)
        document.querySelector(".bank-information .mensaje").textContent = ""
    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()) {
            document.querySelector(".bank-information .mensaje").textContent = "Error: expiration month is a number between 01 and 12"
        }else{
            document.querySelector(".bank-information .mensaje").textContent = "Error: el mes de expiración es un número entre 01 y 12"
        }
    }

    checkValidates(evt.target)
}

function handleYear(evt){
    const year_exp = new RegExp("^2[3-9]|[3-9][0-9]$")
    if (year_exp.test(evt.target.value)){
        isValid(evt.target.parentElement)
        document.querySelector(".bank-information .mensaje").textContent = ""
    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()) {
            document.querySelector(".bank-information .mensaje").textContent = "Error: expiration year is a number between 23 and 99"
        }else{
            document.querySelector(".bank-information .mensaje").textContent = "Error: el año de expiración es un número entre 23 y 99"
        }
    }

    checkValidates(evt.target)
}

function handleCVV(evt){
    const cvv_exp = new RegExp("^[0-9]{3,4}$")
    if (cvv_exp.test(evt.target.value)){
        isValid(evt.target.parentElement)
        document.querySelector(".bank-information .mensaje").textContent = ""
    }else{
        isInvalid(evt.target.parentElement)
        if (socket.isEng()) {
            document.querySelector(".bank-information .mensaje").textContent = "Error: CVV must contains between 3 and 4 numbers."
        }else{
            document.querySelector(".bank-information .mensaje").textContent = "Error: El cvv es una clave entre 3 y 4 numeros";
        }
    }

    checkValidates(evt.target)
}

function checkTaxes(evt){
    var options = JSON.parse(localStorage.getItem("options"))
    var amount = document.querySelector(".form-container .amount-container h2");
    var buscador = new URLSearchParams(window.location.search);

    var total =  cantidad_actual
    if(buscador.get("tickets") != null){
        if (buscador.get("amount") != null) {
            total = amount.getAttribute("tickets") * buscador.get("amount");
        }else{
            total = Number(amount.getAttribute("amount"));
        }
    }else{
        total = cantidad_actual;
    }

    if(options.currency == 1){

        if (evt.target.checked){
            amount.setAttribute("amount",total + taxes)
            amount.textContent = mxnformat(total + taxes)
        }else{
            amount.setAttribute("amount",total)
            amount.textContent = mxnformat(total)
        }
    }else{
        if (evt.target.checked){
            amount.setAttribute("amount",total + taxes)
            amount.textContent = usdformat(total + taxes)
        }else{
            amount.setAttribute("amount",total)
            amount.textContent = usdformat(total)
        }
    }

}

function reCalculateTotal(evt){
    var options = JSON.parse(localStorage.getItem("options"))
    var buscador = new URLSearchParams(window.location.search);
    var boletos= evt.target.value;
    var price = document.querySelector(".amount-container h2")
    var total = buscador.get("amount")*boletos

    price.setAttribute("tickets",boletos)
    cantidad_actual = total;
    taxes  = ((total * .036) + 3) * 1.16


    if (document.getElementById("taxes").checked){
        total = total+taxes
    }

    price.setAttribute("amount",total)

    if (options.currency == 1){
        document.querySelector(".cantidad").textContent = mxnformat(((total * .036) + 3) * 1.16)
        price.textContent = mxnformat(total)
    }else{
        document.querySelector(".cantidad").textContent = usdformat(((total * .036) + 3) * 1.16)
        price.textContent = usdformat(total)
    }
}

export default class App extends React.Component{

    constructor() {
        super();
        localStorage.clear();

        socket.getInformation();

        var buscador = new URLSearchParams(window.location.search);

        if (buscador.get("utm_source") != null) {
            if (buscador.get("id") == 23 && buscador.get("utm_source").localeCompare("SMNYL") === 0) {
                window.location.href="https://payments.savethechildrenmx.org/?id=22&"+window.location.href.split("?")[1].replace("id=23&","")

            }
        }

        if (buscador.get("amount") != null){
            cantidad_actual =Number(buscador.get("amount"))
            taxes = (Number(buscador.get("amount")) *.036 + 3) *1.16
            setTimeout(()=>{
                document.querySelector(".taxes .cantidad").textContent = socket.format(taxes)
                document.querySelector(".button-container button").setAttribute("disabled","disabled")
                document.querySelector(".button-container button").classList.add("disabled")
                var options = localStorage.getItem("options")
                options = JSON.parse(options)
                if (options.link_success_payment.length > 0){
                    document.querySelector(".en_otro_momento").href = options.link_success_payment
                }else{
                    document.querySelector(".en_otro_momento").href = "https://apoyo.savethechildren.mx/gracias-unico"
                }

                if (buscador.get("tickets")!=null){
                    var label = document.createElement("label")
                    var input  = document.createElement("input")

                    input.addEventListener("focus",handleFocus)
                    input.addEventListener("blur",handleBlur)
                    input.value = 1;
                    input.type = "number"
                    input.id = "boletos"

                    document.querySelector(".amount-container h2").setAttribute("tickets",1)
                    label.textContent = "Ingresa el número de boletos que deseas comprar"
                    document.querySelector(".boletos").appendChild(label)
                    document.querySelector(".boletos").appendChild(input)
                    document.querySelector(".boletos").classList.add("is-valid")

                    input.focus()
                    input.addEventListener("keyup", reCalculateTotal)
                }
            },1500)
        }

        if (buscador.get("id") == 23 || buscador.get("id") == 16 ){
            setTimeout(()=>{
                document.getElementById("phone").parentElement.remove();
            },1000)
        }
    }

    sendPay(evt){
        socket.sendPay();
    }
    render() {
        return (
                <div className="App">
                    <div className="form-container">
                        <img src={logo} alt=""/>
                        <div className="label-container">
                            <h1 className="item-1">Hacer donativo a: </h1>
                            <h2>FUNDACION MEXICANA DE APOYO INFANTIL AC</h2>
                        </div>
                        <div className="label-container desc">
                            <h1 className="item-2">Para: </h1>
                            <h2></h2>
                        </div>
                        <div className="amount-container">
                            <h1 className="item-3">Por la cantidad de:</h1>
                            <h2></h2>
                        </div>
                    </div>
                    <div className="line"></div>
                    <div className="information-container">
                        <div className="form-group amount-container item-4">
                            <label>Ingresa la cantidad de tu donativo:</label>
                            <input id={"61"} type="text" inputMode="numeric" onKeyUp={handleAmount} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group item-5">
                            <label>Ingresa tu(s) nombre(s):</label>
                            <input id="firstName" type="text" onKeyUp={handleName} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group item-6">
                            <label>Ingresa tus apellidos:</label>
                            <input id="lastName" type="text" onKeyUp={handleName} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group item-7">
                            <label>Ingresa tus email:</label>
                            <input id="email" type="email" onKeyUp={handleEmail} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group phone item-8">
                            <label>Ingresa tu número telefónico a 10 dígitos:</label>
                            <input id="phone" type="phone" onKeyUp={handlePhone} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group boletos item-9"></div>
                        <div className="form-group taxes is-valid item-10">
                            <input type="checkbox" name="" id="taxes" onChange={checkTaxes}/>
                            <label htmlFor="taxes"><span className="text-1">Deseo agregar</span>
                                <span className="cantidad"></span>
                                <span className="text-2">para cubrir costos de cobranza.</span></label>
                        </div>
                        <div className="mensaje"></div>
                        <div className="button-container item-11">
                            <button type={"button"} onClick={handleClick}>Continuar</button>
                        </div>
                    </div>
                    <div className="bank-information d-none">
                        <div className="form-group item-12">
                            <label>Titular:</label>
                            <input id="58" type="text" onKeyUp={handleName} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group item-13">
                            <label>Ingresa tu número número de tarjeta:</label>
                            <input id="55" type="text" onKeyUp={handleCard} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group item-14">
                            <label>Mes de vencimiento a 2 dígitos:</label>
                            <input id="56" type="phone" onKeyUp={handleMonth} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group item-15">
                            <label>Año de vencimiento a 2 dígitos:</label>
                            <input id="57" type="phone" onKeyUp={handleYear} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="form-group item-16">
                            <label>CVV:</label>
                            <input id="103" type="phone" onKeyUp={handleCVV} onFocus={handleFocus} onBlur={handleBlur}/>
                        </div>
                        <div className="mensaje"></div>
                        <div className="button-container item-17">
                            <button type={"button"} onClick={this.sendPay.bind(this)}>Continuar</button>
                        </div>
                    </div>
                    <Alerts/>
                    <Facturacion focus={handleFocus} blur={handleBlur} email={handleEmail}/>
                </div>
        );
    }
}
